

















import ProductFilters from '@/components/product-filter/product-filters/ProductFilters.vue';
import ProductSearch from '@/components/product-filter/product-search/ProductSearch.vue';
import { FoundProducts } from '@/model/find-products-response';
import { ProductListFilter } from '@/model/product-list-filter';
import Vue from 'vue';

export default Vue.extend({
  name: 'ProductFilterJumbotron',
  components: {
    'product-search': ProductSearch,
    'product-filters': ProductFilters
  },
  props: {
    backgroundImageLink: {
      type: String,
      default: ''
    },
    activeFilter: {
      type: Object as () => ProductListFilter,
      required: true
    },
    foundProducts: {
      type: Object as () => FoundProducts,
      required: true,
    },
    v2Styling: {
      type: Boolean,
      default: false
    },
    showFilters: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundImageUrl(): string {
      return `url('${this.backgroundImageLink}')`;
    }
  },
  watch: {
    activeFilter(newValue: ProductListFilter) {
    },
  },
  methods: {
    submit(event: MouseEvent) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.$emit('updated');
    }
  }
});
